import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108aef77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin":"0","min-height":"40px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Disagree ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Agree ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "strike-through" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Strongly Disagree ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Neutral ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Strongly Agree ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!

  return (_openBlock(), _createBlock(_component_ion_radio_group, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value) = $event)),
    onIonChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('input', _ctx.value)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "12",
            class: "py-4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.question), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col),
          _createVNode(_component_ion_col, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.value=40))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col),
          _createVNode(_component_ion_col, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.value=80))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_radio, {
                mode: "md",
                class: "strike",
                value: 20,
                color: _ctx.color,
                disabled: _ctx.disabled
              }, null, 8, ["color", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_radio, {
                mode: "md",
                class: "strike",
                value: 40,
                color: _ctx.color,
                disabled: _ctx.disabled
              }, null, 8, ["color", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_radio, {
                mode: "md",
                class: "strike",
                value: 60,
                color: _ctx.color,
                disabled: _ctx.disabled
              }, null, 8, ["color", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_radio, {
                mode: "md",
                class: "strike",
                value: 80,
                color: _ctx.color,
                disabled: _ctx.disabled
              }, null, 8, ["color", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_radio, {
                mode: "md",
                class: "strike",
                value: 100,
                color: _ctx.color,
                disabled: _ctx.disabled
              }, null, 8, ["color", "disabled"])
            ]),
            _: 1
          }),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.value=20))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col),
          _createVNode(_component_ion_col, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.value=60))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col),
          _createVNode(_component_ion_col, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.value=100))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}